import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import { getTicketTypes } from "../../store/middleware";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import Engrenagem from "../../assets/images/icons/icon_settings_header.svg";

import { Table } from "./styles";

function Tickets() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [litsTicket, setLitsTicket] = useState([]);

  const getData = async () => dispatch(getTicketTypes()).then((res) => setLitsTicket(res));

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header
          title="Tickets"
          icon={<img src={Engrenagem} alt="Engrenagem" />}
          typeIcon="custom"
          rightButton={
            <button className="buttonRight" onClick={() => navigate("/tickets/new")}>
              <i className="fa fa-plus" aria-hidden="true" />
              Add New Type
            </button>
          }
          t={t}
        />

        <div className="content">
          <Table>
            <div className="bigBoxTableLanguage">
              <table>
                <tbody>
                  <tr>
                    <th>Type</th>
                    <th>Subtypes</th>
                    <th>Status</th>
                    <th style={{ textAlign: "center" }}>Options</th>
                  </tr>

                  {litsTicket?.map((list) => (
                    <tr key={list.id}>
                      <td>{list.nameEnglish}</td>
                      <td>
                        {list.ticketSubTypes.map((item, index) => {
                          return (index === 0 ? "" : ", ") + item.nameEnglish;
                        })}
                      </td>
                      <td>
                        <span style={{ color: list.active ? "#0ED572" : "#FF5666" }}>
                          {list.active ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>
                        <Link to={`/tickets/${list.id}`} state={{ data: list }}>
                          <button>
                            View <i className="fa fa-angle-right" aria-hidden="true"></i>
                          </button>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Table>
        </div>
      </section>
    </div>
  );
}

export default Tickets;
